"use client";

import { useState } from "react";

// vigil.kr 실증 첫 진입 잠금 — 1일 1회. 통과 시 24h 쿠키.
export default function GatePage() {
  const [pw, setPw] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    if (!pw || busy) return;
    setBusy(true);
    setErr("");
    try {
      const res = await fetch("/api/gate", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ password: pw }),
      });
      if (res.ok) {
        const params = new URLSearchParams(window.location.search);
        const next = params.get("next");
        window.location.href = next && next.startsWith("/") ? next : "/";
        return;
      }
      const data = await res.json().catch(() => ({}));
      setErr(data.error || "오류가 발생했습니다");
      setPw("");
    } catch {
      setErr("네트워크 오류");
    }
    setBusy(false);
  }

  return (
    <main className="min-h-screen flex items-center justify-center bg-slate-50 px-6">
      <form
        onSubmit={submit}
        className="w-full max-w-xs rounded-2xl bg-white shadow-sm border border-slate-200 p-7 flex flex-col gap-4"
      >
        <div className="text-center">
          <div className="text-lg font-semibold text-slate-800">Vigil</div>
          <div className="text-xs text-slate-400 mt-1">접근 잠금</div>
        </div>
        <input
          type="password"
          inputMode="text"
          autoFocus
          value={pw}
          onChange={(e) => setPw(e.target.value)}
          placeholder="패스프레이즈"
          className="w-full rounded-lg border border-slate-300 px-3 py-2.5 text-sm outline-none focus:border-blue-500"
        />
        {err && <p className="text-xs text-red-500 text-center">{err}</p>}
        <button
          type="submit"
          disabled={busy || !pw}
          className="w-full rounded-lg bg-blue-600 text-white text-sm font-medium py-2.5 disabled:opacity-40"
        >
          {busy ? "확인 중…" : "잠금 해제"}
        </button>
        <p className="text-[10px] text-slate-300 text-center">하루 1회 인증</p>
      </form>
    </main>
  );
}
